import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as File } from "feather-icons/dist/icons/file.svg";

const PDF = () => {
  const LinkComponent = ({ url, urlName }) => {
    return (
      <Link
        to={url}
        className="flex text-blue-600 hover:text-primary-900 pb-3 hover:underline"
      >
        <File className="mx-1 text-red-400" />
        {urlName}
      </Link>
    );
  };
  const LinkData = [
    {
      url: "/home-page-pdf",
      urlName: "Home Page pdf",
    },
    {
      url: "/realestate-page-pdf",
      urlName: "Real Estate Page pdf",
    },
    {
      url: "/third-party-api-integration-pdf",
      urlName: "Third Party API Integration Page pdf",
    },
    {
      url:"/App-in-box-pdf",
      urlName:"Application in box"
    },
    {
      url:"/digital-transformation-pdf",
      urlName:"Digital Transformation"
    },
    {
      url: "/cloud-services-pdf",
      urlName: "Cloud Consulting and Services Page pdf",
    },
    {
      url:"/identity-access-integration-pdf",
      urlName:"Customer Identity & Access Integration"
    }
  ];
  return (
    <div className="flex flex-col m-5">
      <h3 className="pb-3 pl-1 font-bold">PDF Pages Link :</h3>
      {LinkData.map((item) => {
        return <LinkComponent url={item.url} urlName={item.urlName} />;
      })}
    </div>
  );
};

export default PDF;